<template>
  <WrapWithHint
    v-bind="$props"
    :content="props.content"
    tag="span"
    class="icon no-print"
    :class="props.hintClasses"
  >
    <i class="fa fa-circle-info"></i>
  </WrapWithHint>
</template>

<script setup>
  import WrapWithHint from "./wrap-with-hint.vue";
  import hintProps from "./lib/hint-props";

  const props = defineProps({
    hintClasses: { type: String, required: false, default: "has-text-info" },
    ...hintProps,
  });
</script>

<style lang="scss" scoped>
  span {
    cursor: pointer;
  }
</style>
